import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "date", "time", "namedSlots", "slots", "submit" ]
  // static values = {
  //   quantity: { type: Number, default: 1 },
  //   min: { type: Number, default: 1 },
  //   max: { type: Number, default: 20 },
  //   price: { type: Number, default: 0 },
  //   newRecord: { type: Boolean, default: true }
  // }

  hasTime = false;
  hasNamedSlots = false;

  connect() {
    console.log("order time controller", this.element);

    this.hasTime = this.hasTimeTarget;
    this.hasNamedSlots = this.hasNamedSlotsTarget;

    console.log("time", this.hasTime);
    console.log("named slots", this.hasNamedSlots);

    if(this.hasNamedSlots) {
      this.dateChanged({ target: { value: this.dateTarget.value } });
    }
  }

  dateChanged(e) {
    var date = e.target.value;
    console.log("dateChanged", date);

    // show loading
    if (this.hasTime) {
      // TODO:
      // show loading
      // load new times
    } else if (this.hasNamedSlots) {
      // show loading
      this.namedSlotsTarget.innerHTML = "<div class='spinner-border'><span class='visually-hidden'>Loading...</span></div>";

      fetch(`/order/later/slots?date=${date}`).then(response => response.text()).then( html => {
        this.namedSlotsTarget.innerHTML = html;
      }).catch(function(error) {
        console.error("address lookup error", error);
      })
    }
  }

  timeChanged(e) {
    console.log("timeChanged", e);
  }
}
